<template>
  <div>
    <withdraw-info 
      ref="withdrawInfo"
      :adr_no="adr_no"
      v-show="withdrawInfoShow"
      @cancel="onClickCancelWithdraw"
      @doWithdraw="onClickWithdraw"
      @nextProcess="onClickNextProcess"
    />

    <withdraw-card 
      ref="withdrawCard"
      :adr_no="adr_no"
      :memberId="getMemberId()"
      v-show="withdrawCardShow"
      @cancel="onClickCancelWithdraw"
      @doWithdraw="onClickWithdraw"
    />

    <withdraw-account
      ref="withdrawAccount"
      :adr_no="adr_no"
      v-show="withdrawAccountShow"
      @cancel="onClickCancelWithdraw"
      @doWithdraw="onClickWithdraw"
    />
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import WithdrawInfo from './withdrawInfo';
import WithdrawCard from './withdrawCard';
import WithdrawAccount from './withdrawAccount';
import * as ErrMsg from "@/utils/error_msg";

export default {
  name: "AgelocWithdraw",
  extends: AroBase,
  components: {
    WithdrawInfo,
    WithdrawCard,
    WithdrawAccount
  }, 
  props:{
    adr_no: {
      type: String,
      required: true
    },    
  },
  data() { 
    return {     
      //View Data
      viewData : {
        mileage : {
          // ADR_NO: null,
          // adrPointTotal: null,
          // availablePoints: null,
          // cancelPoint: null,
          // memberId: null,
          // message: null,
          // penaltyOwed: null,
          // priceOwed: null,
          // status: null,
          // type: null,
        },
        pd_detail: {
          // add_price: 0,
          // adr_order_no: null,
          // agm_code: null,
          // agm_detail: null,
          // agm_name: null,
          // bank_account: null,
          // bank_account_holder: null,
          // bank_code: null,
          // bank_name: null,
          // birth: null,
          // cardexpdate: null,
          // cardnumber: null,
          // cms_no: null,
          // cv: 0,
          // delivery_day: null,
          // hand_phone: null,
          // integration: null,
          // order_regdate: null,
          // order_regtime: null,
          // payment_check: null,
          // payment_count: null,
          // payment_day: null,
          // payment_dt: null,
          // payment_target: null,
          // payment_typ: null,
          // pd_amt: null,
          // pd_count:  null,
          // pd_id:  null,
          // pd_name_kr:  null,
          // print_cardnumber:  null,
          // pv: null,
          // sb: null,
          // ship_address1: null,
          // ship_address2: null,
          // ship_name: null,
          // ship_zip1: null,
          // ship_zip2:  null,
          // start_date:  null,
          // start_ym:  null,        
        }
      },
      params : {},

      withdrawInfoShow : true,
      withdrawInfoData : {},

      withdrawCardShow : false,
      withdrawCardData : {},

      withdrawAccountShow : false,
      withdrawAccountData : {},

      testText : ""
    }
  },
  created() {
  },
  mounted() {
    let _this = this;
    
    _this.loadDetail();
  },
  methods: {    
    /**
     * JQuery UI
     */
    initUI(){
      
    },

    /**
     * API Request
     */
    //나의 에이지락 미 철회 정보 가져오기
    apiGetAgelocmeCancel(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_agelocme_cancel`, {
        params: {
          adr_no : _this.adr_no
        }
      });
    },

    //나의 에이지락 미 철회하기
    apiDoAgelocmeCancel(paramData){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/cancel_agelocme`, {
        params: {
          adr_no : _this.adr_no,
          reg_id : _this.getMemberId(),
          ...paramData
        }
      });
    },

    /**
     * Local function
     */
    //데이터 로드
    loadDetail(){
      let _this = this;

      //show loading
      _this.$showLoading();      
      _this.apiGetAgelocmeCancel().then(res=>{
        
        if (res.status === 200 && res.data.status === "0000") {
          _this.viewData = {
            ...res.data            
          };

          //Test Code
          _this.viewData.pd_detail.payment_typ = "2";
          
          //ARO 철회 정보 표시
          _this.withdrawInfoData = {..._this.viewData};   
          _this.$refs.withdrawInfo.initData(_this.withdrawInfoData);
          _this.withdrawInfoShow = true;
          
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});        

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },

    //철회 취소
    onClickCancelWithdraw(){
      let _this = this;
      _this.$router.go(-1);
    },

    //철회 하기
    onClickWithdraw(payment_typ, additionalData){
      let _this = this;

      const options = {cancelLabel: '취소', okLabel:'철회'};         

      let msg = `${_this.adr_no}의 리워드 프로그램을 철회 하시겠습니까?`;  
      if(_this.viewData.addpayment_amt >= 0){
        msg = `${_this.adr_no}의 철회로 인한 추가결제금액은 
        ${_this.$fmt.WON(_this.$nvl(_this.viewData.addpayment_amt,0))} 원입니다.<br/>
        해당 금액은 기존 진행하던 카드 또는 계좌로 결제됩니다.<br/>
        철회 하시겠습니까?`;
      }

      _this.$dialogs.confirm(msg, options).then(res=>{
        if(res.ok){
          _this.withdrawProcess(payment_typ, additionalData);
        }
      });
    },

    //다음 진행
    onClickNextProcess(){
      let _this = this;

      if(_this.AroConst.VALUE_payment_type_credit_card == _this.viewData.pd_detail.payment_typ){
        //신용카드
        _this.withdrawInfoShow = false;

        _this.withdrawCardData = {..._this.viewData};
        _this.$refs.withdrawCard.initData(_this.withdrawCardData);
        _this.withdrawCardShow = true;
        window.scrollTo(0, 0);

      }else if(_this.AroConst.VALUE_payment_type_account_transfer == _this.viewData.pd_detail.payment_typ){
        //계좌이체
        _this.withdrawInfoShow = false;

        _this.withdrawAccountData = {..._this.viewData};
        _this.$refs.withdrawAccount.initData(_this.withdrawAccountData);
        _this.withdrawAccountShow = true;
        window.scrollTo(0, 0);
      }
    },

    //철회
    withdrawProcess(payment_typ, additionalData){
      let _this = this;
      
      let paramData = {
        payment_type : payment_typ
      };
      if(_this.AroConst.VALUE_payment_type_credit_card == payment_typ){
        //신용카드
        paramData = {
          ...paramData,
          ExpDateY : _this.viewData.pd_detail.ExpDateY,
          ExpDateM : _this.viewData.pd_detail.ExpDateM,
          CardNumber : _this.viewData.pd_detail.CardNumber
        };
        
      }else if(_this.AroConst.VALUE_payment_type_account_transfer == payment_typ){
        //계좌이체        
        paramData = {
          ...paramData,
          cms_no : _this.viewData.pd_detail.cms_no,
          birth : additionalData.birth
        };
      }else{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE}).then(res => {});
        return;
      }

      //show loading
      _this.$showLoading();      
      _this.apiDoAgelocmeCancel(paramData).then(res=>{
        
        if (res.status === 200 && res.data.status === "0000") {
          let message = "";
          if(_this.AroConst.VALUE_payment_type_credit_card == payment_typ){
            message = "철회처리가 완료 되었습니다.";
          }else if(_this.AroConst.VALUE_payment_type_account_transfer == payment_typ){
            message = "철회처리가 접수 되었습니다.";
          }

           _this.$dialogs.alert(message).then(res => {
             _this.$router.push(`${_this.$aroBasePath}/agelocCurrentList`);
           });
          
          
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});        

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });   
    }
  }
}
</script>
<style>
a.rew19-btn-border, a.rew19-btn-normal{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/my/ageloc/withdraw.vue